import { useState, useEffect } from "react";
import { Box, Text,TextInput } from "grommet";
import { NumberInput } from "grommet-controls";
import { updateStateHandler } from "../Utils/Utils";

const InputWithText = (props) => {
    // console.log('In InputWithText props obj:', props);

    useEffect(() => {
        setNumber( (props.number && (props.initValue === null || props.initValue === '' )) ? 0 : (props.number === undefined && (props.initValue === null || props.initValue === 0)) ? '' : props.initValue);
    }, []);

    const updateValue = (value) => {
        if (Number(value) < 0)
            return;

        const prevValue = number === '' ? 0 : number;
        const newValue = value === '' ? 0 : value;

        setNumber(value);
        updateStateHandler(props.stateHandler, props.fieldName, Number(value));
        if(props.updateProgressByCheck){
            props.updateProgressByCheck(prevValue, Number(newValue));
        }      
    };
        
    // console.log('props.number >> ', props.number);
    const [number, setNumber] = useState(0);

    return (
        <Box alignContent="between" pad="small">
            <Text alignSelf="start" color="brand" size="18px">
                {props.text}
            </Text>
            <Text alignSelf="end" color="brand" size="xsmall">
                {props.smlText}
            </Text>
            {props.number && (
                <TextInput
                    type="number"
                    style={{ padding: "5px 0 5px 10px", margin: "10px 0 0 0", fontSize: "large"}}
                    value={number}
                    size="small"
                    // disabled={props.disable}
                    readOnly={props.disable}
                    onChange={(event) => {
                        updateValue(event.target.value);
                    }}
                />
            )}
            {!props.number && (
                <TextInput
                    style={{ padding: "5px 0 5px 10px", margin: "10px 0 0 0", color: "#7D4CDB", fontSize: "large"}}
                    value={number}
                    // disabled={props.disable}
                    readOnly={props.disable}
                    onChange={(event) => {
                        updateValue(event.target.value);
                    }}                   
                />
            )}
            <Text alignSelf="end" color="brand" size="small">
                {props.subText}
            </Text>
        </Box>
    );
};

export default InputWithText;
